import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]

import { computed } from 'vue'

import type { PreAllocationTag } from '@/types/qualification-eligibility.types'

import { preAllocationTitle } from './qualificationText'

/** `dot` para as células compactas da grade (só o ponto, com o mesmo título). */

export default /*#__PURE__*/_defineComponent({
  __name: 'PreAllocationBadge',
  props: {
    tag: {},
    variant: { default: 'pill' }
  },
  setup(__props: any) {

const props = __props;



const title = computed(() => preAllocationTitle(props.tag))

return (_ctx: any,_cache: any) => {
  return (_ctx.variant === 'dot')
    ? (_openBlock(), _createElementBlock("i", {
        key: 0,
        class: "inline-block h-1.5 w-1.5 rounded-full bg-orange-500 ring-1 ring-white",
        title: title.value,
        "data-testid": "pre-allocation-badge-dot"
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "inline-flex items-center rounded border border-orange-300 bg-orange-50 px-1 text-[10px] font-bold leading-4 text-orange-700",
        title: title.value,
        "data-testid": "pre-allocation-badge"
      }, " Pré-alocado ", 8, _hoisted_2))
}
}

})